import Image from 'next/image';
import { resolveImageAlt, sanityImage } from '@/lib/sanity/image';
import { cn } from '@/lib/utils/tw-merge';
import type { UiImageProps } from './UiImage.types';

/**
 * A Sanity image filling its (positioned) parent. `sizes` is required rather
 * than defaulted: an image without one matching its real display width makes
 * next/image request the widest candidate everywhere.
 *
 * Decorative images pass `alt=""` explicitly; everything else runs through
 * `resolveImageAlt`.
 */
export function UiImage({ image, sizes, alt, altFallback, className, loading, fetchPriority, onLoad }: UiImageProps) {
    const src = sanityImage.content(image ?? undefined);
    if (!src) return null;

    return (
        <Image
            src={src}
            alt={alt ?? resolveImageAlt(image, altFallback)}
            fill
            sizes={sizes}
            loading={loading}
            fetchPriority={fetchPriority}
            onLoad={onLoad}
            className={cn('object-cover', className)}
        />
    );
}
